<template>
<div class="background" :style="renderBackground()">
    <div class="hero-content">
        <div class="content container">
            <slot />
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: {
        backgroundImage: String
    },
    methods: {
        renderBackground() {
            return {
                'background-image': `url('${this.backgroundImage}')`
            }
        }
    }
}
</script>

<style>
.background {
  align-items: stretch;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  min-height: 50vh;
  width: 100%;
}

.hero-content {
    align-self: center;
    margin: 2rem auto;
    opacity: 0.95;
    padding: 1rem;
}
</style>